import * as React from 'react'

import Svg, { Path } from 'react-native-svg'

import { IconProps } from '../icons'

const ArrowBack = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.144 7.17a.941.941 0 1 0-1.33-1.332l-5.508 5.496a.941.941 0 0 0 0 1.332l5.508 5.496a.941.941 0 1 0 1.33-1.332l-3.896-3.888h11.81a.941.941 0 1 0 0-1.883H7.248l3.896-3.888Z"
      fill={color}
    />
  </Svg>
)

export default ArrowBack
